var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
import { useSafeId } from '../../../core/hooks/useSafeId';
/**
 * @tdr
 */
export var Turkey = svgIcon(function (props) {
    var id1 = useSafeId();
    var id2 = useSafeId();
    return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("g", { clipPath: "url(#".concat(id1, ")") },
            React.createElement("g", { fillRule: "evenodd", clipPath: "url(#".concat(id2, ")"), clipRule: "evenodd" },
                React.createElement("path", { fill: "#E30A17", d: "M-1 0h14v12H-1V0Z" }),
                React.createElement("path", { fill: "#fff", d: "M7.48 6c0 1.38-1.138 2.498-2.543 2.498-1.404 0-2.541-1.119-2.541-2.5s1.137-2.496 2.541-2.496C6.342 3.502 7.48 4.621 7.48 6Z" }),
                React.createElement("path", { fill: "#E30A17", d: "M7.604 6c0 1.104-.908 1.998-2.031 1.998-1.123 0-2.033-.896-2.033-2s.91-1.996 2.033-1.996c1.123 0 2.033.894 2.033 1.998h-.002Z" }),
                React.createElement("path", { fill: "#fff", d: "m7.973 4.833-.021.923-.86.234.85.302-.021.848.552-.663.837.292-.483-.71.59-.707-.907.25-.537-.77v.001Z" }))),
        React.createElement("rect", { width: "11.7", height: "11.7", x: ".15", y: ".15", stroke: "#53565A", strokeWidth: ".3", rx: "5.85" }),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: id1 },
                React.createElement("rect", { width: "12", height: "12", fill: "#fff", rx: "6" })),
            React.createElement("clipPath", { id: id2 },
                React.createElement("path", { fill: "#fff", d: "M-1 0h14v12H-1z" })))));
});
//# sourceMappingURL=Turkey.js.map